import React from "react";
import { Card } from "react-bootstrap";
import { useTranslation } from "react-i18next";

import InfoRow from "./InfoRow.tsx";
import { PerformanceData } from "../ProjectDetails.types.tsx";
import { SubHeaderLabel } from "../../Labels.tsx";

const PerformanceDataCard: React.FC<{ performanceData: PerformanceData }> = ({
  performanceData,
}) => {
  const { t } = useTranslation();

  const { cooling_capacity, cop } = performanceData || {};

  return (
    <Card className="mb-3 border-0 h-100">
      <Card.Body className="d-flex flex-column">
        <SubHeaderLabel textAlign="left" className="mb-2">
          {t("projectDetails.performanceDataCard.title")}
        </SubHeaderLabel>

        <div className="flex-grow-1">
          <InfoRow
            label={t("projectDetails.performanceDataCard.coolingCapacity")}
            value={`${cooling_capacity} ton`}
          />
          <InfoRow label={t("projectDetails.performanceDataCard.cop")} value={cop} />
        </div>
      </Card.Body>
    </Card>
  );
};

export default PerformanceDataCard;
